import { render, staticRenderFns } from "./ComponentLEDDetail.vue?vue&type=template&id=2b817674&"
import script from "./ComponentLEDDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentLEDDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports